import { render, staticRenderFns } from "./item-gallery-full.vue?vue&type=template&id=7f21002b&scoped=true"
import script from "./item-gallery-full.vue?vue&type=script&lang=js"
export * from "./item-gallery-full.vue?vue&type=script&lang=js"
import style0 from "./item-gallery-full.vue?vue&type=style&index=0&id=7f21002b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21002b",
  null
  
)

export default component.exports